import { useState, useEffect } from "react";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { useNavigate } from "react-router-dom";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug, getClients } from "../services/apiService";

const tabsData = [
  { id: "commercial", label: "Commercial Clients" },
  { id: "government", label: "Government Clients" },
  { id: "systemIntegrators", label: "System Integrators" },
];

const normalizeType = (type = "") => type.toLowerCase().replace(/\s+/g, "");
const CLIENTS_BASE_URL = "http://localhost:5000";

function Clients() {
  const navigate = useNavigate();
  const slug = useSlug();

  const [tab, setTab] = useState("commercial");
  const [metaData, setMetaData] = useState({});
  const [clientsList, setClientsList] = useState([]);

  useEffect(() => {
    console.log("CLIENTS_BASE_URL:", CLIENTS_BASE_URL);
    const fetchData = async () => {
      try {
        const [slugRes, clientsRes] = await Promise.all([
          getPagesBySlug(slug.toLowerCase()),
          getClients(),
        ]);

        setMetaData(slugRes.data);
        setClientsList(clientsRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [slug]);

  const categorizedClients = {
    commercial: [],
    government: [],
    systemIntegrators: [],
  };

  clientsList.forEach((client) => {
    const type = normalizeType(client.type);
    if (type == "commercialclient") {
      categorizedClients.commercial.push(client);
    }
    if (type === "governmentclient") {
      categorizedClients.government.push(client);
    }
    if (type === "systemintegrators") {
      categorizedClients.systemIntegrators.push(client);
    }
  });

  const tabContent = {
    commercial: {
      h1: "Some of Our Direct Commercial Clients",
      p: "We’re proud to work with trusted companies across industries.",
    },
    government: {
      h1: "Our Public Sector / Government Clients",
      p: "Supporting government organizations with secure technology solutions.",
    },
    systemIntegrators: {
      h1: "System Integrators We Work With",
      p: "Collaborating with global system integration partners.",
    },
  };

  return (
    <>
      <SEO {...metaData} />
      <div className="py-24 text-center font-roboto">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#29327f]">
          Trusted by Industry Leaders
        </h1>
        <p className="mt-6 text-lg text-[#404040] max-w-3xl mx-auto">
          Building long-term partnerships with organizations that believe in
          technology-driven growth.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-center gap-4 mb-14">
          {tabsData.map((item) => (
            <button
              key={item.id}
              onClick={() => setTab(item.id)}
              className={`px-6 py-3 rounded-md text-lg font-medium transition-all ${
                tab === item.id
                  ? "bg-activeColor text-white shadow"
                  : "bg-white text-[#0F172A] border"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="text-3xl font-extrabold text-[#434253]">
            {tabContent[tab].h1}
          </h2>
          <p className="text-[#5F6870] text-xl mt-4">{tabContent[tab].p}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          {categorizedClients[tab]?.map((client) => (
            <div
              key={client._id}
              className="flex items-center justify-center border-[2px] border-[#FFEAE7] rounded-xl w-[220px] h-[140px]"
            >
              <img
                src={`${client.logo}`}
                alt={client.name}
                className="object-contain max-h-[140px]"
              />
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-16 mb-6">
          <button
            onClick={() => navigate("/contact")}
            className="bg-activeColor text-white text-xl px-8 py-3 rounded-md hover:bg-red-600 transition-all"
          >
            Reach Us
          </button>
        </div>
      </div>

      <ScrollToTopButton />
    </>
  );
}

export default Clients;
